import React, { useEffect, useState } from "react";
import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import toastError from "../../errors/toastError";
import api from "../../services/api";

export function QueuesFilter({ userQueues = [], onFiltered }) {
  const [queues, setQueues] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    if (userQueues.length > 0) {
      setQueues(userQueues);
    } else {
      api.get("/queue")
        .then(({ data }) => setQueues(data))
        .catch((err) => toastError(err));
    }
  }, [userQueues]);

  const onChange = (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box style={{ padding: "0 10px 10px" }}>
      <Autocomplete
        multiple
        size="small"
        options={queues}
        value={selecteds}
        onChange={(e, v) => onChange(v)}
        getOptionLabel={(option) => option.name}
        getOptionSelected={(option, value) => option.id === value.id}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              style={{ borderColor: option.color, color: option.color }}
              label={option.name}
              {...getTagProps({ index })}
              size="small"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Filtrar por departamento"
          />
        )}
      />
    </Box>
  );
}
